<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <app-ds-icon name="close-x" size="icon-size-2" color="var(--color-core-neutral-7)"></app-ds-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <app-account-greenness-notification  [success]="success" (closeNotification)="close()"></app-account-greenness-notification>
</ion-content>
